import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './CustomToastStyles.css';
import useAuth from './useAuth';
import Header from './Header.js';
import Sidebar from './Sidebar.js';
import logo from './vdc_logo.png';
import Footer from './Footer.js';
import jsPDF from 'jspdf';
import pdficon from "./pdf.png";


function Edit_Fuel_form() {
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const API_BASE_URL1 = process.env.REACT_APP_API_BASE_URL1;
    const token = localStorage.getItem('authToken');
    const navigate = useNavigate();
    const [vehicleModals, setVehicleModals] = useState([]);
    const [vehicleTypes, setVehicleTypes] = useState([]);
    const [vehicleNumbers, setVehicleNumbers] = useState([]);
    const [vehicleMakes, setVehicleMakes] = useState([]);
     const [RptMgrName, setRptMgrName] = useState('');
            const [AdtMgrName, setAdtMgrName] = useState('');
            const [ActMgrName, setActMgrName] = useState('');
    const [fuelTypes, setFuelTypes] = useState([]);
    const [error, setError] = useState('');
    const [EmpCode, setEmpCode] = useState('');
    const [uploadError, setUploadError] = useState("");
    const [Grade, setGrade] = useState('');
    const [loading, setLoading] = useState(true);
    const [responseMessage, setResponseMessage] = useState('');
    const [fuelImages, setImgRows] = useState('');
    const [fuelContentsImages, setFuelContentsImages] = useState('');
    const [flashAlert, setFlashAlert] = useState(null);
    const [flashAlert1, setFlashAlert1] = useState(null);
    const [flashAlert2, setFlashAlert2] = useState(null);
    const { id } = useParams();
    const [errors, setErrors] = useState({
        rpt_mgr_status: '', // Initial errors can go here (empty or predefined)
    });
    const Loader = () => (
        <div style={{ textAlign: 'center', marginTop: '20px' }}>
            <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
            </div>
            <p>Loading...</p>
        </div>
    );
    const [formData, setFormData] = useState({
        comp_name: '',
        emp_code: '',
        grade: '',
        dept_name: '',
        designation_name: '',
        report_mngr: '',
        mode_of_travel: '',
        to_city: '',
        guesthouse: '',
        bank_acnum: '',
        bank_name: '',
        audit_status: '',
        ifsc_code: '',
        total_fuel_amt: '',
        total_fuel_qty: '',
        audit_approved_amount: '',
        audit_approved_date: '',
        account_approved_date: '',
        account_remarks: '',
        audit_remarks: '',
        account_mngr: '',
        total_fixed: '',
        img: []  // To store the image files
    });

    //fetch fuel form data
    const fetchFuelFormData = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}getFuelFormById1/${id}`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const result = await response.json();

            if (result.status && result.data) {
                const fuelForm = result.data;
                const fuelRows = result.fuelFormContents;
                const fuelImages = result.fuelFormImages;
                const fuelContentsImages = result.fuelFormContentsImages;
                setRptMgrName(result.reportManagerName.comp_name || '');
                setAdtMgrName(result.auditManagerName.comp_name || '');
                setActMgrName(result.accountsManagerName.comp_name || '');
                setFormData({
                    id: fuelForm.id || '',
                    emp_code: fuelForm.emp_code || '',
                    comp_name: fuelForm.comp_name || '',
                    mobile: fuelForm.mobile || '',
                    dated: fuelForm.dated || '',
                    bank_acnum: fuelForm.bank_acnum || '',
                    bank_name: fuelForm.bank_name || '',
                    ifsc_code: fuelForm.ifsc_code || '',
                    location_name: fuelForm.location_name || '',
                    grade: fuelForm.grade || '',
                    dept_name: fuelForm.dept_name || '',
                    designation_name: fuelForm.designation_name || '',
                    report_mngr: fuelForm.report_mngr || '',
                    isSubmited: fuelForm.isSubmited || 'NO',
                    total_fuel_qty: fuelForm.total_fuel_qty || '0',
                    total_fuel_amt: fuelForm.total_fuel_amt || '0',
                    createdDTM: fuelForm.createdDTM || '',
                    createdBy: fuelForm.createdBy || '',
                    rpt_mgr_status: fuelForm.rpt_mgr_status || '',
                    manager_remarks: fuelForm.manager_remarks || '',
                    audit_approved_amount: fuelForm.audit_approved_amount || '',
                    total_fixed: fuelForm.total_fixed || '0',
                    audit_status: fuelForm.audit_status || '',
                    audit_remarks: fuelForm.audit_remarks || '',
                    account_status: fuelForm.account_status || '',
                    account_remarks: fuelForm.account_remarks || '',
                    audit_approved_date: fuelForm.audit_approved_date || '',
                    manager_approved_date: fuelForm.manager_approved_date || '',
                    account_approved_date: fuelForm.account_approved_date || '',
                    utr: fuelForm.utr || '',
                    utr_date: fuelForm.utr_date || '',
                    account_mngr: fuelForm.account_mngr || '',
                    trans_code: fuelForm.trans_code || '',
                });

                if (fuelRows && fuelRows.length > 0) {
                    setTransportRows(fuelRows);
                    console.log("Fuel Rows:", fuelRows);
                }

                if (fuelImages && fuelImages.length > 0) {
                    setImgRows(fuelImages);
                }

                if (fuelContentsImages && fuelContentsImages.length > 0) {
                    setFuelContentsImages(fuelContentsImages);
                }

            } else {
                setError(result.message || 'Failed to fetch form data');
            }
        } catch (error) {
            console.error('Fetch error:', error);
            setError('Failed to fetch items');
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        fetchFuelFormData();
    }, [id]);



    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSubmitAllowed, setIsSubmitAllowed] = useState(true);
    const [transportRows, setTransportRows] = useState([{
        id: 1,
        dated: '',
        vehicle_number: '',
        vehicle_make: '',
        vehicle_modal: '',
        vehicle_type: '',
        fuel_type: '',
        fuel_unit: '',
        fuel_rate: '',
        fuel_quantity: '',
        fuel_amount: '', receipt: []
    }]);

    useAuth();  // Custom hook for authentication

    const handleBackClick = () => {
        navigate("/finance_fuel_forms");
    };

    const handleAddTransportRow = () => {
        setTransportRows([
            ...transportRows,
            {
                id: transportRows.length + 1, dated: '', vehicle_number: '',
                vehicle_make: '', vehicle_modal: '', vehicle_type: '', fuel_type: '',
                fuel_unit: '', fuel_rate: '', fuel_quantity: '', fuel_amount: '', receipt: []
            }
        ]);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };


    // fetch vehicle modals
    const fetchVehicleModals = async (id) => {
        try {
            const response = await fetch(`${API_BASE_URL}getVehicleModels`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const result = await response.json();
            if (result.status) {
                setVehicleModals(result.data);
            } else {
                setError(result.message);
            }
        } catch (error) {
            console.error('Fetch error:', error);
            setError('Failed to fetch items');
        } finally {
            setLoading(false);
        }
    };

    // fetch vehicle types
    const fetchVehicleTypes = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}getVehicleTypes`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const result = await response.json();
            if (result.status) {
                setVehicleTypes(result.data);
            } else {
                setError(result.message);
            }
        } catch (error) {
            console.error('Fetch error:', error);
            setError('Failed to fetch items');
        } finally {
            setLoading(false);
        }
    };

    // fetch vehicle numbers
    const fetchVehicleNumbers = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}getVehicleNumbers`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const result = await response.json();
            if (result.status) {
                setVehicleNumbers(result.data);
            } else {
                setError(result.message);
            }
        } catch (error) {
            console.error('Fetch error:', error);
            setError('Failed to fetch items');
        } finally {
            setLoading(false);
        }
    };

    // fetch fuel types
    const fetchFuelTypes = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}getFuelTypes`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const result = await response.json();
            if (result.status) {
                setFuelTypes(result.data);
            } else {
                setError(result.message);
            }
        } catch (error) {
            console.error('Fetch error:', error);
            setError('Failed to fetch items');
        } finally {
            setLoading(false);
        }
    };

    // fetch vehicle makes
    const fetchVehicleMakes = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}getVehicleMakes`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const result = await response.json();
            if (result.status) {
                setVehicleMakes(result.data);
            } else {
                setError(result.message);
            }
        } catch (error) {
            console.error('Fetch error:', error);
            setError('Failed to fetch items');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchVehicleTypes();
        fetchVehicleModals();
        fetchVehicleNumbers();
        fetchFuelTypes();
        fetchVehicleMakes();
    }, [navigate]);



    const handleTransportChange = (index, e) => {
        const { name, value, type, files, id } = e.target;
        const newTransportRows = [...transportRows];
        newTransportRows[index] = { ...newTransportRows[index], [name]: value };


        // Update  
        if (name === 'vehicle_number') {
            // newTransportRows[index].fuel_amount = newTransportRows[index].fuel_rate * newTransportRows[index].fuel_quantity;
            const vehicle = vehicleNumbers.find(vehicle => vehicle.vehicle_number === value);
            if (vehicle) {
                newTransportRows[index].vehicle_modal = vehicle.vehicle_modal;
                newTransportRows[index].vehicle_type = vehicle.vehicle_type;
                newTransportRows[index].fuel_type = vehicle.fuel_type;
                newTransportRows[index].fuel_unit = vehicle.fuel_unit;
            } else {
                newTransportRows[index].vehicle_modal = '';
                newTransportRows[index].vehicle_make = '';
                newTransportRows[index].vehicle_type = '';
                newTransportRows[index].fuel_type = '';
                newTransportRows[index].fuel_unit = '';
            }
        }

        // Update fuel amount when rate or quantity changes (if both are present and quantity is not 0)
        if (name === 'fuel_rate' || name === 'fuel_quantity') {
            // Calculate the fuel amount based on rate and quantity
            const rate = parseFloat(newTransportRows[index].fuel_rate) || 0;
            const quantity = parseFloat(newTransportRows[index].fuel_quantity) || 0;
            newTransportRows[index].fuel_amount = rate * quantity;
            //execute after completing above


        }

        if (parseFloat(newTransportRows[index].fuel_quantity) === 0) {
            // If quantity is 0, fuel_amount can be manually entered
            if (name === 'fuel_amount') {
                newTransportRows[index].fuel_amount = parseFloat(value) || 0;
            } else {
                newTransportRows[index].fuel_amount = '';
            }
        } else {
            // If quantity is not 0, calculate fuel_amount automatically
            const rate = parseFloat(newTransportRows[index].fuel_rate) || 0;
            const quantity = parseFloat(newTransportRows[index].fuel_quantity) || 0;
            newTransportRows[index].fuel_amount = rate * quantity;
        }


        const MAX_SIZE = 1 * 1024 * 1024; // 1MB in bytes

        // If the input type is 'file' and there are selected files
        if (type === 'file' && files.length > 0) {
            const file = files[0]; // Get the first file selected

            // Check if the file exceeds the size limit
            if (file.size > MAX_SIZE) {
                const errorMsg = `File "${file.name}" exceeds the 1MB limit. Please upload a smaller file.`;
                setFlashAlert1(`File exceeds the 1MB limit. Please upload a smaller file.`);
                setTimeout(() => {
                    setFlashAlert1(null); // Remove the alert after 5 seconds
                }, 5000);
                toast.error(errorMsg); // Show the error message via toast

                e.target.value = ""; // Clear the file input

                // Optionally, reset the value in the transport row state if needed
                newTransportRows[index] = { ...newTransportRows[index], [name]: null };

                setTransportRows(newTransportRows); // Update the transport rows state
                return; // Stop further execution if the file is too large
            }

            // If the file size is within the limit, store the file in the transport row
            newTransportRows[index] = { ...newTransportRows[index], [name]: file };
        } else {
            // For other input types (non-file), just update the value normally
            newTransportRows[index] = { ...newTransportRows[index], [name]: value };
        }

        // Update the transport rows state
        setTransportRows(newTransportRows);


    };


    // Calculate the total amount
    const calculateTotal = () => {
        // Calculate the total amount, make total of all total_fuel_amt rows
        const total_amt = transportRows.reduce((total, row) => total + (parseFloat(row.fuel_amount)), 0);
        //update formData
        setFormData(prevState => ({
            ...prevState,
            total_fuel_amt: total_amt
        }));

    };


    // Calculate the total quantity
    const calculateTotalQuantity = () => {


        const total_qty = transportRows.reduce((total, row) => total + (parseFloat(row.fuel_quantity) || 0), 0);
        //update formData
        setFormData(prevState => ({
            ...prevState,
            total_fuel_qty: total_qty
        }));


    };

    useEffect(() => {
        calculateTotal();
        calculateTotalQuantity();
    }, [transportRows]);

    const handleSubmit = async () => {
        // Validate remarks field
        if (!formData.account_remarks || formData.account_remarks.trim() === '') {
            setErrors((prevErrors) => ({
                ...prevErrors,
                account_remarks: "Account remarks are required",
            }));
            return; // Stop submission
        } else {
            setErrors((prevErrors) => ({
                ...prevErrors,
                account_remarks: null, // Clear error if fixed
            }));
        }
        if (!window.confirm("Are you sure you want to submit?")) {
            return; // Exit if user cancels
        }

        setIsSubmitting(true); // Disable button & show loading text

        try {
            const response = await fetch(`${API_BASE_URL}updateFmFuelStatus`, {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                    formId: formData.id,  // Assuming `formData` contains form ID
                    account_status: formData.account_status,
                    account_remarks: formData.account_remarks,
                    utr: formData.utr,
                    utr_date: formData.utr_date
                    
                }),
            });

            const result = await response.json();

            if (result.status) {
                alert('Status updated successfully!');
                window.location.reload();
            } else {
                alert('Failed to update status.');
            }
        } catch (error) {
            console.error('Error:', error);
            alert('Something went wrong. Please try again.');
        }

        setIsSubmitting(false); // Re-enable button after request
    };

    const generatePDF = () => {
            const doc = new jsPDF();
            
            // Extract Month Name from First Transport Row
            let travelMonth = "";
            if (transportRows.length > 0 && transportRows[0].dated) {
                const firstTravelDate = transportRows[0].dated; // Format: "DD-MM-YYYY"
                const dateParts = firstTravelDate.split("-");
        
                if (dateParts.length === 3) {
                    const [day, month, year] = dateParts; 
                    const dateObj = new Date(year, parseInt(month, 10) - 1, 1); // Ensure month is zero-based
                    travelMonth = dateObj.toLocaleString("en-US", { month: "long" });
                }
            }
        
            // Add Logo
            doc.addImage(logo, 'PNG', 5, 10, 15, 15);
        
            // Title
            doc.setFontSize(22);
            doc.setFont('helvetica', 'bold');
            doc.text("Tour/Travel Fuel Finance Approval Form", 105, 20, null, null, 'center');
        
            // Line Separator
            doc.setDrawColor(0, 0, 0);
            doc.setLineWidth(0.5);
            doc.line(10, 25, 200, 25);
        
            // Header Section (Company Info)
            doc.setFontSize(12);
            doc.setFont('helvetica', 'normal');
            doc.text(`Emp Name: ${formData.comp_name}`, 10, 35);
            doc.text(`Employee No: ${formData.emp_code}`, 105, 35);
            doc.text(`Department: ${formData.dept_name}`, 10, 45);
            doc.text(`Location: ${formData.location_name}`, 125, 45);
            doc.text(`Report Manager: ${formData.report_mngr}`, 10, 55);
            doc.text(`Created On: ${formData.createdDTM}`, 105, 55);
        
            // Table for Detailed Form Data
            doc.autoTable({
                startY: 60,
                head: [['Field', 'Value']],
                body: [
                    ['Month', travelMonth],
                    ['Approved Amount', formData.audit_approved_amount],
                    ['Audit Status', formData.audit_status === 'Pending' ? '' : formData.audit_status],
                    ['Account Status', formData.account_status === 'Pending' ? '' : formData.account_status],
                    ['Manager Remarks', formData.manager_remarks],
                    ['Audit Remarks', formData.audit_remarks],
                    ['Accounts Remarks', formData.account_remarks],
                    ['Manager Approved Date', formData.manager_approved_date],
                    ['Audit Approved Date', formData.audit_approved_date],
                    ['Accounts Manager', formData.account_mngr],
                    ['Trans Code', formData.trans_code],
                    ['UTR', formData.utr],
                    ['UTR Date', formData.utr_date],
                    ['Focus Code', formData.focus_code],
                    ['Bank Account No.', formData.bank_acnum],
                    ['Bank Name', formData.bank_name],
                    ['IFSC Code', formData.ifsc_code],
                ],
                theme: 'grid',
                headStyles: {
                    fillColor: [0, 104, 116],
                    textColor: [255, 255, 255],
                    fontSize: 12,
                    font: 'helvetica',
                },
                bodyStyles: {
                    fontSize: 10,
                    font: 'helvetica',
                },
                margin: { top: 100, left: 10, right: 10 },
                styles: {
                    halign: 'center',
                    valign: 'middle',
                },
            });
        
            // Get Position After Table
            let yPosition = doc.lastAutoTable.finalY + 10;
        
            // Prepared by Section
            doc.setFontSize(12);
            doc.setFont('helvetica', 'bold');
            doc.text("Prepared by:", 10, yPosition);
            doc.setFont('helvetica', 'normal');
            doc.text(`${formData.emp_code} (${formData.comp_name})`, 10, yPosition + 10);
            doc.text(`Date: ${formData.createdDTM}`, 10, yPosition + 20);
        
            // Approved by Section
            doc.setFontSize(12);
            doc.setFont('helvetica', 'bold');
            doc.text("Approved by:", 135, yPosition);
            doc.setFont('helvetica', 'normal');
            doc.text(`Date: ${formData.manager_approved_date}`, 135, yPosition + 10);
        
            // Audit Approved by Section
            doc.setFontSize(12);
            doc.setFont('helvetica', 'bold');
            doc.text("Audit Approved by:", 10, yPosition + 30);
            doc.setFont('helvetica', 'normal');
            doc.text(`Date: ${formData.audit_approved_date}`, 10, yPosition + 40);
        
            // Approved by (Empty Signatures)
            doc.setFontSize(12);
            doc.setFont('helvetica', 'bold');
            doc.text("Approved by:", 135, yPosition + 30);
            doc.setFont('helvetica', 'normal');
            doc.text(`______________________`, 135, yPosition + 37);
            doc.text(`______________________`, 135, yPosition + 45);
        
            // Footer
            const totalPages = doc.internal.getNumberOfPages();
            doc.setFontSize(10);
            doc.setFont('helvetica', 'normal');
            doc.text(`Page ${totalPages}`, 105, 290, null, null, "center");
        
            // Save PDF
            doc.save("finance_fuel_form.pdf");
        };





    return (
        <div className="hold-transition sidebar-mini layout-fixed" style={{ fontSize: '12px' }}>
            <div className="wrapper">
                <Header />
                <Sidebar />
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1 className="m-0" style={{ fontSize: '20px' }}>Edit Reporting Manager Fuel Form ({formData?.trans_code})</h1>
                                </div>
                                <div className="col-sm-6">
                                    <ol className="breadcrumb float-sm-right">
                                    <button
                                            type="button"
                                            className="btn btn-primary pull-right"
                                            onClick={generatePDF}
                                        >
                                            Generate PDF
                                        </button>
                                        <li className="breadcrumb-item"><a href="/dashboard">Home</a></li>
                                        <li className="breadcrumb-item active">New Fuel Form</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    {loading ? (
                        <Loader /> // Show loader if loading is true
                    ) : (
                        <>
                            <section className="col-lg-12">
                                <div className="card" style={{ borderTop: '3px solid #CC5500' }}>
                                    <div className="card-body">
                                        <form method="post" acceptCharset="utf-8">
                                            <fieldset style={{ border: '1px #ccc solid', padding: '10px' }}>
                                                <div className="box-body">
                                                    <div className="row">

                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="name">Employee No
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="emp_code"
                                                                    id="name"
                                                                    value={formData?.emp_code || ''}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    placeholder="Employee No/Consultant"
                                                                    readOnly
                                                                />

                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="name">Name </label>
                                                                <input
                                                                    type="text"
                                                                    name="comp_name"
                                                                    id="name"
                                                                    value={formData.comp_name}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    placeholder="Name"
                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="name">Employee Band</label>
                                                                <input
                                                                    type="text"
                                                                    name="grade"
                                                                    id="name"
                                                                    value={formData.grade}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"

                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="name">Department</label>
                                                                <input
                                                                    type="text"
                                                                    name="dept_name"
                                                                    id="name"
                                                                    value={formData.dept_name}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"

                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="name">Designation </label>
                                                                <input
                                                                    type="text"
                                                                    name="designation_name"
                                                                    id="name"
                                                                    value={formData.designation_name}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"

                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="name">Mobile No
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="mobile"
                                                                    id="name"
                                                                    value={formData.mobile}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="bank_name">Bank Name
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="bank_name"
                                                                    id="bank_name"
                                                                    value={formData.bank_name}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="bank_acnum">Bank Ac.No
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="bank_acnum"
                                                                    id="bank_acnum"
                                                                    value={formData.bank_acnum}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="ifsc_code">IFSC Code
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="ifsc_code"
                                                                    id="ifsc_code"
                                                                    value={formData.ifsc_code}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="name">Reporting Manager
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="report_mngr"
                                                                    id="name"
                                                                    value={formData.report_mngr}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label htmlFor="name">Location
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="report_mngr"
                                                                    id="name"
                                                                    value={formData.location_name}
                                                                    onChange={handleChange}
                                                                    className="form-control input-font"
                                                                    readonly="true"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </fieldset>
                                            <fieldset style={{ border: '1px #ccc solid', padding: '10px' }}>
                                                <center>
                                                    <span className="btn btn-warning" style={{ fontSize: '12px', color: 'white', backgroundColor: '#CC5500' }}>
                                                        Details of Fuel Form
                                                    </span>
                                                </center>

                                                <div className="transport-table-container mb-3 text-right">


                                                    {/* Responsive Table Wrapper */}
                                                    <div className="table-responsive">
                                                        <table className="table table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <td colSpan="12"></td>
                                                                </tr>
                                                                <tr className="header-row text-center">
                                                                    <th>Date<span className="text-danger">*</span></th>
                                                                    <th>Vehicle Number</th>
                                                                    <th>Type<span className="text-danger">*</span></th>
                                                                    <th>Modal<span className="text-danger">*</span></th>
                                                                    <th>Fuel<span className="text-danger">*</span></th>
                                                                    <th>Fuel Unit<span className="text-danger">*</span></th>
                                                                    <th>Fuel Rate</th>
                                                                    <th>Quantity</th>
                                                                    <th>Total</th>
                                                                    <th>Fixed Amount</th>
                                                                    <th>Bills Images</th>

                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {transportRows.map((row, index) => (
                                                                    <tr key={index}>
                                                                        <td>
                                                                            <input
                                                                                type="date"
                                                                                name="dated"
                                                                                value={row.dated}
                                                                                onChange={(e) => handleTransportChange(index, e)}
                                                                                className="form-control input-font"
                                                                                max={new Date().toISOString().split("T")[0]}
                                                                                required={index === 0}
                                                                                disabled
                                                                            />
                                                                        </td>
                                                                        <td>

                                                                            <input placeholder='Number' list="vm" className='form-control input-font'
                                                                                name='vehicle_number' id='vehicle_number'
                                                                                value={row.vehicle_number}
                                                                                onChange={(e) => handleTransportChange(index, e)} disabled />
                                                                            <datalist id="vm">
                                                                                {vehicleNumbers.map((vehicleNumber) => (
                                                                                    <option key={vehicleNumber.id} value={vehicleNumber.vehicle_number}>
                                                                                        {vehicleNumber.vehicle_number}
                                                                                    </option>
                                                                                ))}
                                                                            </datalist>
                                                                        </td>
                                                                        <td>
                                                                            <input className="form-control input-font"
                                                                                type="text"
                                                                                readOnly
                                                                                value={row.vehicle_type}
                                                                                name="vehicle_type"
                                                                            />

                                                                        </td>

                                                                        <td>
                                                                            <input className="form-control input-font"
                                                                                type="text"
                                                                                readOnly
                                                                                value={row.vehicle_modal}
                                                                                name='vehicle_modal' id='vehicle_modal'
                                                                            />

                                                                        </td>
                                                                        <td>
                                                                            <select readOnly onChange={(e) => handleTransportChange(index, e)}
                                                                                className="form-control input-font"
                                                                                name='fuel_type' id='fuel_type'>
                                                                                {row.fuel_type
                                                                                    ? <option value={row.fuel_type}>{row.fuel_type}</option>
                                                                                    : <option value="">Fuel Type</option>
                                                                                }

                                                                                {fuelTypes.map((fuelType) => (
                                                                                    <option key={fuelType.id} value={fuelType.fuel_type}>
                                                                                        {fuelType.fuel_type}
                                                                                    </option>
                                                                                ))}
                                                                            </select>
                                                                        </td>
                                                                        <td>
                                                                            <input className="form-control input-font"
                                                                                type="text"
                                                                                readOnly
                                                                                value={row.fuel_unit}
                                                                                name='fuel_unit' id='fuel_unit'
                                                                            />

                                                                        </td>
                                                                        <td> <input className="form-control input-font"
                                                                            type="number"
                                                                            value={row.fuel_rate}
                                                                            name="fuel_rate"
                                                                            onChange={(e) => handleTransportChange(index, e)}
                                                                            disabled
                                                                        />
                                                                        </td>
                                                                        <td>

                                                                            <input className="form-control input-font"
                                                                                type="number"
                                                                                value={row.fuel_quantity}
                                                                                name="fuel_quantity"
                                                                                onChange={(e) => { handleTransportChange(index, e) }}
                                                                                disabled
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <input
                                                                                className="form-control input-font"
                                                                                type="number"
                                                                                value={row.fuel_amount}
                                                                                name="fuel_amount"
                                                                                onChange={(e) => handleTransportChange(index, e)}
                                                                                disabled
                                                                            />

                                                                        </td>
                                                                        <td style={{ minWidth: '4rem' }}>
                                                                            <input className="form-control input-font"
                                                                                type="number"
                                                                                value={Math.trunc(row.fixed_amount)}
                                                                                name="fixed_amount"
                                                                                onChange={(e) => { handleTransportChange(index, e) }}
                                                                                
                                                                                disabled
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            {fuelContentsImages && fuelContentsImages.length > 0 ? (
                                                                                fuelContentsImages
                                                                                    .filter((i) => i.fuel_form_content_id === row.id) // Filter images by fuel_form_content_id
                                                                                    .map((i) => {
                                                                                        const imageUrl = `${API_BASE_URL1}assets/uploads/${i.img}`;
                                                                                        return (
                                                                                            <div key={i.id} style={{ margin: '5px', display: 'inline-block' }}>
                                                                                                <a href={imageUrl} target="_blank" rel="noopener noreferrer">
                                                                                                    {i.img.toLowerCase().endsWith('.pdf') ? (
                                                                                                        <img
                                                                                                            src={pdficon}
                                                                                                            alt="PDF document"
                                                                                                            style={{
                                                                                                                width: '20px',
                                                                                                                height: '20px',
                                                                                                                objectFit: 'cover'
                                                                                                            }}
                                                                                                        />
                                                                                                    ) : (
                                                                                                        <img
                                                                                                            src={imageUrl}
                                                                                                            alt="Document"
                                                                                                            style={{
                                                                                                                width: '20px',
                                                                                                                height: '20px',
                                                                                                                objectFit: 'cover'
                                                                                                            }}
                                                                                                        />
                                                                                                    )}
                                                                                                </a>
                                                                                            </div>
                                                                                        );
                                                                                    })
                                                                            ) : (
                                                                                <div>No documents available.</div>
                                                                            )}


                                                                            <input
                                                                                type="file"
                                                                                name="receipt"
                                                                                id="receipt"
                                                                                accept=".jpg,.jpeg,.png,.pdf"
                                                                                onChange={(e) => handleTransportChange(index, e)}
                                                                                className="form-control input-font"
                                                                                disabled
                                                                            />
                                                                        </td>

                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                            <tfoot>
                                                                <tr>
                                                                    <td colSpan="8"><b>Total Fuel Qty: {formData.total_fuel_qty}</b></td>
                                                                    <td colSpan="1" className="text-right font-weight-bold">
                                                                        Total Amount : ₹ {formData.total_fuel_amt} </td>
                                                                        <td className="text-right font-weight-bold">
                                                                        Total Fixed Amt : ₹ {formData.total_fixed} </td>
                                                                </tr>
                                                            </tfoot>
                                                        </table>
                                                    </div>
                                                </div>
                                            </fieldset>
                                            <fieldset style={{ border: '1px #ccc solid', padding: '10px' }}>
                                                <center>
                                                    <span className="btn btn-primary" style={{ fontSize: '12px', color: 'white', backgroundColor: '#CC5500' }}>
                                                        Additional Documents
                                                    </span>
                                                </center>
                                                <div className="document-table-container" style={{ marginBottom: '20px', textAlign: 'right' }}>
                                                    <table className="document-table" style={{ marginTop: '10px' }}>
                                                        <thead>
                                                            <tr>
                                                                <th style={{ textAlign: 'center' }}>Click to Preview</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {/* Loop through fuelImages and display each document's image */}
                                                            {fuelImages.length > 0 ? (
                                                                <tr>
                                                                    <td colSpan="1" style={{ textAlign: 'center' }}>
                                                                        <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap' }}>
                                                                            {fuelImages.map((document) => {
                                                                                // Construct the image URL outside the JSX expression
                                                                                const imageUrl = `${API_BASE_URL1}assets/uploads/${document.img}`;

                                                                                return (
                                                                                    <div key={document.id} style={{ margin: '10px' }}>
                                                                                        <a href={imageUrl} target="_blank" rel="noopener noreferrer" className="position-relative">
                                                                                            {document.img.toLowerCase().endsWith('.pdf') ? (
                                                                                                // If the document is a PDF, show the PDF icon
                                                                                                <img
                                                                                                    src={pdficon} // Replace with the actual path to your PDF icon
                                                                                                    alt={`PDF Document ${document.id}`}
                                                                                                    style={{
                                                                                                        width: '100px',
                                                                                                        height: '100px',
                                                                                                        objectFit: 'cover',
                                                                                                        margin: '5px',
                                                                                                    }}
                                                                                                />
                                                                                            ) : (
                                                                                                // Otherwise, show the image
                                                                                                <img
                                                                                                    src={imageUrl}
                                                                                                    alt={`Document ${document.id}`}
                                                                                                    style={{
                                                                                                        width: '79px',
                                                                                                        height: '100px',
                                                                                                        objectFit: 'cover',
                                                                                                        margin: '5px',
                                                                                                    }}
                                                                                                />
                                                                                            )}
                                                                                        </a>
                                                                                    </div>
                                                                                );
                                                                            })}
                                                                        </div>

                                                                    </td>
                                                                </tr>
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan="1" style={{ textAlign: 'center' }}>
                                                                        {error ? error : 'No documents available.'}
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </fieldset>


                                            {/* Upload Images Section */}
                                            <section className="col-lg-12">


                                                {/* Reporting Manager Section */}
                                                <div className="row mt-3">
                                                    {/* Reporting Manager Status */}
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label htmlFor="rpt_mgr_status" className="form-label" style={{ fontSize: '12px' }}>
                                                                Reporting Manager Status <span style={{ color: 'red' }}>*</span>
                                                            </label>
                                                            <select
                                                                name="rpt_mgr_status"
                                                                id="rpt_mgr_status"
                                                                value={formData.rpt_mgr_status || ''}
                                                                onChange={handleChange}
                                                                className="form-control custom-select"
                                                                required
                                                                disabled
                                                            >
                                                                <option value="Pending">Pending</option>
                                                                <option value="Approved">Approved</option>
                                                                <option value="Rejected">Rejected</option>

                                                            </select>
                                                            {errors.rpt_mgr_status && (
                                                                <div style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>
                                                                    {errors.rpt_mgr_status}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* Reporting Manager Remarks */}
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label htmlFor="remarks" className="form-label" style={{ fontSize: '12px' }}>
                                                                Reporting Manager Remarks <span style={{ color: 'red' }}>*</span>
                                                            </label>
                                                            <textarea
                                                                name="manager_remarks"
                                                                id="remarks"
                                                                value={formData.manager_remarks || ''}
                                                                onChange={handleChange}
                                                                className="form-control"
                                                                required
                                                                disabled
                                                            ></textarea>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="audit_status">Audit Status
                                                                <span style={{ color: 'red' }}>*</span>
                                                            </label>
                                                            <select
                                                                name="audit_status"
                                                                id="audit_status"
                                                                value={formData.audit_status}
                                                                onChange={handleChange}
                                                                disabled
                                                                className="form-control input-font custom-select"

                                                            >

                                                                <option value="Pending">Pending</option>
                                                                <option value="Approved">Approved</option>
                                                                <option value="Rejected">Rejected</option>
                                                            </select>
                                                            {errors.audit_status && (
                                                                <div style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>
                                                                    {errors.audit_status}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div><div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="name">
                                                                Audit Approved Amount
                                                                <span style={{ color: 'red' }}>*</span>
                                                            </label>
                                                            <input
                                                                type="text"  // Keep the type as text
                                                                name="audit_approved_amount"
                                                                id="name"
                                                                value={formData.audit_approved_amount !== '' ? Math.floor(formData.audit_approved_amount) : ''}
                                                                onChange={handleChange}
                                                                onInput={(e) => {
                                                                    // Allow only numeric input (no decimal, no special characters)
                                                                    const inputValue = e.target.value;
                                                                    if (/[^0-9]/.test(inputValue)) {
                                                                        // If non-numeric character is found, remove it
                                                                        e.target.value = inputValue.replace(/[^0-9]/g, '');
                                                                    }
                                                                }}
                                                                className="form-control input-font"
                                                                required
                                                                disabled
                                                            />
                                                        </div>

                                                    </div>

                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="audit_remarks">Audit Remarks
                                                                <span style={{ color: 'red' }}>*</span>
                                                            </label>

                                                            <textarea
                                                                id="audit_remarks"
                                                                name="audit_remarks"
                                                                value={formData.audit_remarks}
                                                                onChange={handleChange}
                                                                className="form-control"
                                                                required
                                                                rows='1'
                                                                disabled
                                                            ></textarea>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label style={{ fontSize: '12px' }} htmlFor="account_status">Finance Manager Status
                                                                <span style={{ color: 'red' }}>*</span>
                                                            </label>
                                                            <select
                                                                name="account_status"
                                                                id="account_status"
                                                                value={formData.account_status || ''}
                                                                onChange={handleChange}
                                                                className="form-control input-font"
                                                                required
                                                            >
                                                                <option value="Pending">Pending</option>
                                                                <option value="Approved">Approved</option>
                                                               
                                                            </select>
                                                            {errors.account_status && (
                                                                <div style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>
                                                                    {errors.account_status}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label style={{ fontSize: '12px' }} htmlFor="account_remarks">Finance Manager Remarks
                                                                <span style={{ color: 'red' }}>*</span>
                                                            </label>

                                                            <textarea name="account_remarks"
                                                                required
                                                                id="remarks"
                                                                value={formData.account_remarks || ''}
                                                                onChange={handleChange}
                                                                className="form-control "


                                                            ></textarea>
                                                            {errors.account_remarks && (
                                                                <div style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>
                                                                    {errors.account_remarks}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='row'>
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="name">UTR

                                                            </label>
                                                            <input
                                                                type="text"
                                                                name="utr"
                                                                id="name"
                                                                value={formData.utr}

                                                                onChange={handleChange}
                                                                className="form-control input-font"
                                                                placeholder="utr"


                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="name">date

                                                            </label>
                                                            <input
                                                                type="date"
                                                                name="utr_date"
                                                                id="utr_date"
                                                                value={formData.utr_date}

                                                                onChange={handleChange}
                                                                className="form-control input-font"
                                                                placeholder="utr date"


                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                {uploadError && <div className="alert alert-danger text-center p-2">{uploadError}</div>}

                                                {/* Buttons */}
                                                <div className="d-flex justify-content-center mt-3 gap-3">

                                                    <button type="button" className="btn btn-secondary" onClick={handleBackClick}>
                                                        Cancel
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn btn-success"
                                                        disabled={isSubmitting}
                                                        onClick={handleSubmit}
                                                    >
                                                        {isSubmitting ? 'Submitting...' : 'Submit'}
                                                    </button>
                                                </div>
                                                <div className="col-sm-12 row" style={{ width: '100%' }}>
                            <div style={{ border: '#cccccc 1px solid' }} className="col-sm-3">
                                <b>Prepared by </b>
                                <p> {formData.emp_code} ({formData.comp_name})<br /> Date
                                    : {formData.createdDTM}
                                </p>
                            </div>
                            <div style={{ border: '#cccccc 1px solid' }} className="col-sm-3">
                                {formData.rpt_mgr_status === 'Approved' && (
                                    <>
                                        <b> Approved by</b>
                                        <p> {formData.report_mngr} ({RptMgrName})<br /> Date
                                            : {formData.manager_approved_date}
                                        </p>
                                    </>
                                )}
                            </div>
                            <div style={{ border: '#cccccc 1px solid' }} className="col-sm-3">
                                {formData.audit_status === 'Approved' && (
                                    <>
                                        <b> Verified by Audit Team</b>
                                        <p>                         <span>
                                            {formData.audit_mngr} ({AdtMgrName})<br /> Date
                                            : {formData.audit_approved_date}
                                        </span>
                                        </p>
                                    </>
                                )}
                            </div>
                            <div style={{ border: '#cccccc 1px solid' }} className="col-sm-3">
                                {formData.account_status === 'Approved' && (
                                    <>
                                        <b> Verified by Finance Team</b>
                                        <p>                         <span>
                                            {formData.account_mngr} ({ActMgrName})<br /> Date
                                            : {formData.account_approved_date}
                                        </span>
                                        </p>
                                    </>
                                )}
                            </div>



                        </div>
                                            </section>


                                        </form>
                                        <div className="d-flex justify-content-center mt-3">
                                            {/* {formData?.isSubmited === 'NO' && (<button onClick={sendForApproval} className='btn btn-info ml-3'>Send for Approval</button>)} */}
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </>
                    )}
                </div>
                <Footer />
            </div>
            <ToastContainer />
        </div>
    )
}

export default Edit_Fuel_form